import React, { Component } from 'react';
import animateScrollTo from 'animated-scroll-to';
import NavDots from '@components/NavDots/NavDots';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Css from './ScrollContainer.scss';
class ScrollContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultActive: props.active !== undefined ? props.active : 0,
      active: props.active !== undefined ? props.active : 0,
      animationActive: false,
      children: React.Children.toArray(props.children),
      pageWidth:
        this.props.pageWidth !== undefined
          ? this.props.pageWidth
          : window.innerWidth
    };

    this.animationTimeout = null;
  }

  componentDidUpdate(prevProps, prevState) {
    // Typical usage (don't forget to compare props):
    if (this.props.children !== prevProps.children) {
      this.setState({
        children: React.Children.toArray(this.props.children)
      });
    }

    if (prevState.pageWidth !== window.innerWidth) {
      this.setState({
        pageWidth: window.innerWidth
      });
      this.setCurrentPageHandler(0);
    }

    const element = document.getElementById('lets-connect-form');
    if (element !== null) {
      if (
        (window.location.pathname === '/' && this.state.active === 3) ||
        window.location.pathname === '/experiences-faq'
      ) {
        element.classList.add('d-none');
      } else {
        element.classList.remove('d-none');
      }
    }
  }

  setCurrentPageHandler = activePage => {
    const currentState = this.state.active;
    const panelEl = document.getElementsByClassName('panel')[currentState];
    const panelFirst = document.getElementsByClassName('panel')[0];

    if (
      activePage < 0 ||
      activePage > this.state.children.length - 1 ||
      activePage === this.state.active
    ) {
      if (
        activePage === this.state.active &&
        !panelEl.classList.contains('animated')
      ) {
        panelEl.className += ' animated';
      }
      return false;
    }

    if (window.innerWidth < 992) {
      this.setState({
        animationActive: true,
        active: activePage
      });
      animateScrollTo(
        document.querySelector('#' + this.state.children[activePage].props.id)
      );
      panelFirst.classList.remove('d-none');
      setTimeout(() => {
        this.setState({ animationActive: false });
      }, 1000);
      return true;
    }

    const animationType =
      this.state.active < activePage ? 'fadeOut' : 'fadeOut';
    const animationInType =
      this.state.active < activePage ? 'fadeInUpBig' : 'fadeInDownBig';
    this.setState({
      animationActive: true,
      active: activePage
    });

    panelEl.classList.add(animationType);
    panelEl.classList.add('d-none');
    clearTimeout(this.animationTimeout);
    this.animationTimeout = setTimeout(() => {
      panelEl.classList.remove(animationType);
      panelEl.classList.remove('fadeInUpBig');
      panelEl.classList.remove('fadeInDownBig');
      panelEl.classList.remove('animated');
      panelEl.classList.remove('d-flex');
    }, 400);

    window.removeEventListener('scroll', this.handleScroll);

    const panelActive = document.getElementsByClassName('panel')[activePage];
    panelActive.className += ' animated d-flex ' + animationInType;
    panelActive.classList.remove('d-none');
    panelActive.classList.remove('fadeOut');

    setTimeout(() => {
      window.addEventListener('scroll', this.handleScroll);
    }, 500);
    setTimeout(() => {
      this.setState({ animationActive: false });
    }, 1500);
  };

  scrollToEndHandler = e => {
    const delta = e.wheelDelta;
    if (delta > 0) {
      this.setCurrentPageHandler(this.state.active - 1);
    } else {
      this.setCurrentPageHandler(this.state.active + 1);
    }
    return false;

    /*if (window.pageYOffset > (this.state.active * window.innerHeight) ) {
            let positionCount = Math.floor( currentPos / window.innerHeight) + 1;
            this.setCurrentPageHandler((positionCount >= this.state.children.length)? this.state.children.length - 1 : positionCount);
        } else if ( window.pageYOffset < (this.state.active * window.innerHeight) ) {
            let positionCount = Math.floor( currentPos / window.innerHeight);
            this.setCurrentPageHandler(positionCount);
        }*/
  };

  handleScroll = e => {
    if (
      (e.srcElement !== undefined &&
        e.srcElement.closest !== undefined &&
        e.srcElement.closest('div.scrollable') !== null) ||
      window.innerWidth < 992
    ) {
      return true;
    }
    // Clear our timeout throughout the scroll
    if (this.state.animationActive === false) {
      this.scrollToEndHandler(e);
    }
    return false;
  };

  setActivePage = e => {
    let currentPage = 0;
    React.Children.map(this.state.children, (child, i) => {
      if (
        window.pageYOffset >
        document.getElementById(child.props.id).offsetHeight
      ) {
        currentPage++;
      }
    });
    // const currentPage = Math.floor(window.pageYOffset / window.innerHeight);
    this.setState({
      active: currentPage
    });
  };

  handleMobileScroll = e => {
    if (this.state.animationActive === false) {
      // Clear our timeout throughout the scroll
      window.clearTimeout(this.isMobileScrolling);
      // Set a timeout to run after scrolling ends
      this.isMobileScrolling = setTimeout(() => this.setActivePage(e), 100);
    }
  };

  componentDidMount = () => {
    window.addEventListener('wheel', this.handleScroll, { passive: true });
    if (window.innerWidth < 992) {
      window.addEventListener('scroll', this.handleMobileScroll);
    } else {
      document.getElementsByClassName('panel')[
        this.state.defaultActive
      ].className += ' animated';
    }
    window.scrollTo(0, 0);

    if (this.props.autoScroll !== undefined) {
      setTimeout(
        () => this.setCurrentPageHandler(this.props.autoScroll.active),
        this.props.autoScroll.delay
      );
    }

    window.addEventListener('reload', this.reload);
    window.addEventListener('goto', props => {
      return this.setCurrentPageHandler(props.detail.pageNo);
    });
  };

  reload = () => {
    this.setCurrentPageHandler(this.state.defaultActive);
    if (this.props.autoScroll !== undefined) {
      setTimeout(
        () => this.setCurrentPageHandler(this.props.autoScroll.active),
        this.props.autoScroll.delay
      );
    }
  };

  componentWillUnmount = () => {
    window.removeEventListener('wheel', this.handleScroll);
    window.removeEventListener('reload', this.reload);
    window.removeEventListener('goto', props => {
      return this.setCurrentPageHandler(props.detail.pageNo);
    });
    if (window.innerWidth < 992) {
      window.removeEventListener('scroll', this.handleMobileScroll);
    }
  };

  render() {
    const { hideNavDots, pageHeight } = this.props;
    const { active, children } = this.state;

    return (
      <div className={'js-container'}>
        {!hideNavDots && (
          <NavDots
            activePage={active}
            pageCount={children.length}
            pageHeight={pageHeight}
            click={index => this.setCurrentPageHandler(index)}
          />
        )}

        {children}

        {active !== 0 && (
          <span
            className={Css['nav-up']}
            onClick={() => this.setCurrentPageHandler(active - 1)}
          >
            <FontAwesomeIcon icon={['far', 'chevron-up']} />
          </span>
        )}
        {active + 1 < children.length && (
          <span
            className={Css['nav-down']}
            onClick={() => this.setCurrentPageHandler(active + 1)}
          >
            <FontAwesomeIcon icon={['far', 'chevron-down']} />
          </span>
        )}
      </div>
    );
  }
}

export default ScrollContainer;



// WEBPACK FOOTER //
// ./src/components/ScrollContainer/ScrollContainer.js